import { createOnboarding } from '@biscuits/client';

export const categorizeOnboarding = createOnboarding(
  'categorize',
  ['categorize'],
  true,
);
